import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addTofilterProjects,
  removeFromFilterProject
} from "../../../features/projects/projectsSlice";

const Project = ({ projectName, colorClass, id }) => {
  const { filterProjects } = useSelector((state) => state.projects);
  const dispatch = useDispatch();
  const handleChecked = (e, projectName) => {
    if (e.target.checked) {
      dispatch(addTofilterProjects(projectName));
    } else {
      dispatch(removeFromFilterProject(projectName));
    }
  };

  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className={colorClass}
        checked={filterProjects.includes(projectName) ? true : false}
        onChange={(e) => handleChecked(e, projectName)}
      />
      <p className="label">{projectName}</p>
    </div>
  );
};

export default Project;
